import type { Currency } from '@ps/web-core-enums';
import type { SingleAvailableOpportunity } from '@ps/web-sports-api-types';
import type { BetDefinition, BettableOpportunities, PlaceBetResp } from '@ps/web-sports-types';
import { merge } from 'lodash';

import type { Entity } from '../entities';
import { widgetView } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent } from '../utils';

import { createMultipleEntities } from './createMultipleEntities';
import { createSingleEntities } from './createSingleEntities';
import { createSportsBetEntity } from './createSportsBetEntity';

interface BetPlacedProps {
  response: PlaceBetResp;
  betDefinitions: BetDefinition[];
  bettableOpportunities: BettableOpportunities;
  opportunities: SingleAvailableOpportunity[];
  currency: Currency;
}

export const betPlaced = (
  context: TrackingContextValue,
  { response, betDefinitions, bettableOpportunities, opportunities, currency }: BetPlacedProps
) => {
  const entities: Entity[] = [
    ...createSingleEntities(bettableOpportunities.SINGLE),
    ...createMultipleEntities(opportunities)(
      bettableOpportunities.MULTIPLE,
      response.result?.flatMap((result) => result.runners ?? [])
    )
  ];

  response.result?.forEach((result) => {
    const sportsBetEntity: Entity | null = createSportsBetEntity(
      result,
      betDefinitions,
      currency,
      bettableOpportunities
    );

    if (sportsBetEntity) entities.push(sportsBetEntity);
  });

  const betPlacedContext = {
    category: context.category,
    widget: merge(context.widget, { widgetContext: 'BET_RECEIPT' }),
    entities
  };

  GAEvent({ action: 'Bet placed' }, betPlacedContext);
  widgetView({}, betPlacedContext);
};
